import { generateTestId } from "@client-shared";

export const setCustomersStatsTestId = (identifier: string): string => generateTestId("CustomersStats", identifier);

// Specific testId setters for tests
export const setCustomersStatsContainerTestId = (): string => setCustomersStatsTestId("container");
